import { styled } from "@mui/material";
import TextField, {TextFieldProps} from '@mui/material/TextField';

export const MailTemplateTextField = styled(TextField)<TextFieldProps>(() => ({
    width: '100%'
}));